export function parseRootClassIds(rawClassIds) {
	if (rawClassIds == null) return [];

	const tokens = Array.isArray(rawClassIds)
		? rawClassIds.flatMap((value) => String(value ?? "").split(","))
		: String(rawClassIds).split(",");

	const seen = new Set();
	const classIds = [];
	for (const token of tokens) {
		const classId = String(token ?? "").trim();
		if (!classId || seen.has(classId)) continue;
		seen.add(classId);
		classIds.push(classId);
	}
	return classIds;
}

export function normalizeStudentIdentifier(value) {
	if (value === null || value === undefined) return "";
	const raw = String(value).trim();
	if (!raw) return "";

	const digits = raw.replace(/\D+/g, "");
	if (digits) {
		return digits.replace(/^0+/, "") || "0";
	}
	return raw.toUpperCase();
}

export function buildStudentSectionLookup(classListRows = []) {
	const byStudentId = new Map();
	for (const row of classListRows || []) {
		if (!Array.isArray(row)) continue;
		const classId = String(row[0] ?? "").trim();
		const normalizedStudentId = normalizeStudentIdentifier(row[6]);
		if (!classId || !normalizedStudentId) continue;
		if (!byStudentId.has(normalizedStudentId)) {
			byStudentId.set(normalizedStudentId, classId);
		}
	}
	return byStudentId;
}

export function getSectionGroupsFromStudents({
	students = [],
	classListRows = [],
	rootClassIds = [],
}) {
	const normalizedRootIds = parseRootClassIds(rootClassIds);
	const byStudentId = buildStudentSectionLookup(classListRows);
	const groups = new Map(normalizedRootIds.map((classId) => [classId, []]));

	for (const student of students || []) {
		const normalizedStudentId = normalizeStudentIdentifier(student?.std_id_matched);
		if (!normalizedStudentId) continue;
		const classId = byStudentId.get(normalizedStudentId);
		if (!classId) continue;
		if (!groups.has(classId)) groups.set(classId, []);
		groups.get(classId).push(student);
	}

	return normalizedRootIds
		.map((classId) => ({
			classId,
			students: groups.get(classId) || [],
		}))
		.filter((group) => group.students.length > 0);
}
